/**
 * Inputs: phrase id. Outputs: chrome-free full-screen card for restaurant or driver staff.
 */

import { Link, useParams } from "react-router";
import { SmartClose } from "./SmartBack.tsx";
import { phraseTitle, phrasesForTrip } from "@shared/phrases.ts";
import { useTrip } from "../app/trip.tsx";
import { DriverCard } from "./DriverCard.tsx";

export function ShowCardPage() {
  const { phraseId } = useParams();
  const { trip } = useTrip();
  if (!trip) return <main className="present-shell">Loading card…</main>;
  const phrase = phrasesForTrip(trip.thaiPhrases).find((row) => row.id === phraseId);
  if (!phrase) {
    return (
      <main className="present-shell">
        <p>That card is not on this trip yet.</p>
        <Link className="btn" to="/essentials/cards">Back</Link>
      </main>
    );
  }
  return (
    <main className="present-shell" role="document">
      <SmartClose fallback="/essentials/cards" />
      <section className="present-card" style={{ viewTransitionName: "phrase-card" }}>
        <p className="present-kicker">{phraseTitle(phrase)}</p>
        <p className="present-thai" lang="th">{phrase.thai}</p>
        <p className="present-english">{phrase.english}</p>
        <p className="present-roman">{phrase.romanization}</p>
        {!phrase.translationReviewed ? (
          <p className="banner">Phrase aid only. Thai not owner-reviewed yet.</p>
        ) : (
          <p className="muted">Reviewed wording.</p>
        )}
      </section>
    </main>
  );
}

export function ShowDriverPage() {
  const { id } = useParams();
  const { trip } = useTrip();
  const place = trip?.places.find((p) => p.id === id);
  if (!place) return <main className="present-shell">Place not found.</main>;
  return (
    <main className="present-shell">
      <SmartClose fallback="/essentials" />
      <section className="present-card">
        <DriverCard place={place} />
      </section>
    </main>
  );
}
